export default "__VITE_ASSET__BmrpzE_h__"